const C = require("../constants");

const otherSaleSelectAction = (data) => {
    return {
        type: C.OTHER_SALE_SELECT,
        data
    }
};

export {otherSaleSelectAction};


// WEBPACK FOOTER //
// ./src/actions/OtherSaleSelectAction.js